import { useDispatch } from 'react-redux';
import { LoginUserRequest, TwoFactorLoginRequest } from '../entities/login';
import { login, twoFactorLogin } from '../store/auth/auth-actions';

const useLoginUser = () => {
  const dispatch = useDispatch();

  const loginUser = async (request: LoginUserRequest) => {
    await dispatch(
      login(
        request.username,
        request.password,
        request.recaptcha,
        request.callback,
      ),
    );
  };
  return [loginUser];
};

const useTwoFactorLogin = () => {
  const dispatch = useDispatch();

  const twoFactorLoginUser = async (request: TwoFactorLoginRequest) => {
    await dispatch(
      twoFactorLogin(request.pin, request.token, request.callback),
    );
  };

  return [twoFactorLoginUser];
};

export { useLoginUser, useTwoFactorLogin };
